<div class="form-row">
  <div class="form-group col-md-6">
    <label class="form-label">Repeat Option</label>
    <select
      class="form-control"
      [(ngModel)]="recurringFrequency.FrequencyType"
      (change)="changeRecurringFrequencyType($event)"
      [ngModelOptions]="{ standalone: true }"
    >
      <option value="1">Daily</option>
      <option value="2">Weekly</option>
      <option value="3">Monthly</option>
      <option value="4">Yearly</option>
    </select>
  </div>
  <div class="form-group col-md-3">
    <label class="form-label">Repeat Every</label>
    <input
      type="number"
      class="form-control"
      [min]="1"
      [(ngModel)]="recurringFrequency.Interval"
      required
      [ngClass]="{ 'is-invalid': !recurringFrequency.Interval }"
      name="Interval"
    />
  </div>
  <div class="form-group col-md-3">
    <label class="form-label"> </label>
    <span class="form-text" *ngIf="recurringFrequency.FrequencyType === 1"
      >Day/s</span
    >
    <span class="form-text" *ngIf="recurringFrequency.FrequencyType === 2"
      >Week/s</span
    >
    <span class="form-text" *ngIf="recurringFrequency.FrequencyType === 3"
      >Month/s</span
    >
    <span class="form-text" *ngIf="recurringFrequency.FrequencyType === 4"
      >Year/s</span
    >
  </div>
  <div
    class="row col-md-12 pt-1"
    *ngIf="recurringFrequency.FrequencyType === 2"
  >
    <span
      (click)="changeRecurringByDay('SU', 'multiple')"
      [ngClass]="{ 'btn-main': recurringFrequency.ByDay.indexOf('SU') !== -1 }"
      class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
      >S</span
    >
    <span
      (click)="changeRecurringByDay('MO', 'multiple')"
      [ngClass]="{ 'btn-main': recurringFrequency.ByDay.indexOf('MO') !== -1 }"
      class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
      >M</span
    >
    <span
      (click)="changeRecurringByDay('TU', 'multiple')"
      [ngClass]="{ 'btn-main': recurringFrequency.ByDay.indexOf('TU') !== -1 }"
      class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
      >T</span
    >
    <span
      (click)="changeRecurringByDay('WE', 'multiple')"
      [ngClass]="{ 'btn-main': recurringFrequency.ByDay.indexOf('WE') !== -1 }"
      class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
      >W</span
    >
    <span
      (click)="changeRecurringByDay('TH', 'multiple')"
      [ngClass]="{ 'btn-main': recurringFrequency.ByDay.indexOf('TH') !== -1 }"
      class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
      >T</span
    >
    <span
      (click)="changeRecurringByDay('FR', 'multiple')"
      [ngClass]="{ 'btn-main': recurringFrequency.ByDay.indexOf('FR') !== -1 }"
      class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
      >F</span
    >
    <span
      (click)="changeRecurringByDay('SA', 'multiple')"
      [ngClass]="{ 'btn-main': recurringFrequency.ByDay.indexOf('SA') !== -1 }"
      class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
      >S</span
    >
  </div>
  <div
    class="form-group col-md-3"
    *ngIf="recurringFrequency.FrequencyType === 4"
  >
    <label class="form-label">Repeat on</label>
    <select
      class="form-control"
      [(ngModel)]="recurringFrequency.ByMonth"
      (change)="changeRecurringByMonth($event)"
      [ngModelOptions]="{ standalone: true }"
    >
      <option value="1">January</option>
      <option value="2">February</option>
      <option value="3">March</option>
      <option value="4">April</option>
      <option value="5">May</option>
      <option value="6">June</option>
      <option value="7">July</option>
      <option value="8">August</option>
      <option value="9">September</option>
      <option value="10">October</option>
      <option value="11">November</option>
      <option value="12">December</option>
    </select>
  </div>
  <div
    class="form-group col-md-12"
    *ngIf="
      recurringFrequency.FrequencyType === 3 ||
      recurringFrequency.FrequencyType === 4
    "
  >
    <div class="btn-group" role="group" aria-label="">
      <button
        type="button"
        class="btn btn-main"
        (click)="changeRecurringDayType('day')"
        [ngClass]="{
          'btn-main': recurringFrequency.DayType === 'day',
          'btn-outline': recurringFrequency.DayType === 'month'
        }"
      >
        Day of the month
      </button>
      <button
        type="button"
        class="btn btn-outline"
        (click)="changeRecurringDayType('month')"
        [ngClass]="{
          'btn-main': recurringFrequency.DayType === 'month',
          'btn-outline': recurringFrequency.DayType === 'day'
        }"
      >
        Week of the month
      </button>
    </div>
  </div>
  <div
    class="row col-md-12"
    *ngIf="
      recurringFrequency.FrequencyType === 3 ||
      recurringFrequency.FrequencyType === 4
    "
  >
    <div
      class="form-group col-md-12 form-inline"
      *ngIf="recurringFrequency.DayType === 'day'"
    >
      Every
      <input
        type="number"
        class="form-control ml-2 mr-3"
        style="width: 75px !important"
        [min]="1"
        [(ngModel)]="recurringFrequency.ByMonthDay"
        required
        [ngClass]="{ 'is-invalid': !recurringFrequency.ByMonthDay }"
        name="ByMonthDay"
      />
      of the month
    </div>
    <div class="col-md-3" *ngIf="recurringFrequency.DayType === 'month'">
      <select
        class="form-control"
        [(ngModel)]="recurringFrequency.BySetPos"
        (change)="changeRecurringBySetPos($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        <option value="1">First</option>
        <option value="2">Second</option>
        <option value="3">Third</option>
        <option value="4">Fourth</option>
        <option value="5">Last</option>
      </select>
    </div>
    <div
      class="col-md-9 invoice-date-picker"
      *ngIf="recurringFrequency.DayType === 'month'"
    >
      <span
        (click)="changeRecurringByDay('SU', 'single')"
        [ngClass]="{ 'btn-main': recurringFrequency.ByDay === 'SU' }"
        class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
        >S</span
      >
      <span
        (click)="changeRecurringByDay('MO', 'single')"
        [ngClass]="{ 'btn-main': recurringFrequency.ByDay === 'MO' }"
        class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
        >M</span
      >
      <span
        (click)="changeRecurringByDay('TU', 'single')"
        [ngClass]="{ 'btn-main': recurringFrequency.ByDay === 'TU' }"
        class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
        >T</span
      >
      <span
        (click)="changeRecurringByDay('WE', 'single')"
        [ngClass]="{ 'btn-main': recurringFrequency.ByDay === 'WE' }"
        class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
        >W</span
      >
      <span
        (click)="changeRecurringByDay('TH', 'single')"
        [ngClass]="{ 'btn-main': recurringFrequency.ByDay === 'TH' }"
        class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
        >T</span
      >
      <span
        (click)="changeRecurringByDay('FR', 'single')"
        [ngClass]="{ 'btn-main': recurringFrequency.ByDay === 'FR' }"
        class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
        >F</span
      >
      <span
        (click)="changeRecurringByDay('SA', 'single')"
        [ngClass]="{ 'btn-main': recurringFrequency.ByDay === 'SA' }"
        class="border border-secondary col-auto px-3 py-2 rounded-circle ml-3"
        >S</span
      >
    </div>
  </div>
  <div class="form-group col-md-3">
    <label class="form-label">End</label>
    <select
      class="form-control"
      [(ngModel)]="recurringFrequency.EndType"
      (change)="changeRecurringEndType($event)"
      [ngModelOptions]="{ standalone: true }"
    >
      <option value="1">Never</option>
      <option value="2">Until</option>
      <option value="3">Count</option>
    </select>
  </div>
  <div class="form-group col-md-3" *ngIf="recurringFrequency.EndType == 3">
    <label class="form-label">Count</label>
    <input
      type="number"
      class="form-control"
      [min]="1"
      [(ngModel)]="recurringFrequency.Count"
      required
      [ngClass]="{ 'is-invalid': !recurringFrequency.Count }"
      name="RecurringCount"
    />
  </div>
  <div class="form-group col-md-3" *ngIf="recurringFrequency.EndType == 2">
    <label class="form-label">End Date</label>
    <input
      type="date"
      class="form-control"
      [ngModel]="recurringFrequency.Until | date: 'yyyy-MM-dd'"
      required
      (ngModelChange)="recurringFrequency.Until = $event"
      [ngClass]="{ 'is-invalid': !recurringFrequency.Until }"
      name="RecurrenceUntil"
      [min]="minDate.toISOString().split('T')[0]"
    />
  </div>
</div>
